import { useState } from "react";
import ConversationItem from "./ConversationItem";
import NewConversationModal from "./NewConversationModal";
import Skeleton from "react-loading-skeleton";
import "./style.css";

export default function ConversationsList({
  conversations,
  selectedConversation,
  onConversationSelect,
  onStartNewConversation,
  currentUser,
  loading,
  onlineUsers,
  onConversationDeleted,
}) {
  const [showNewConversationModal, setShowNewConversationModal] = useState(false);

  const handleNewConversation = (participantId) => {
    onStartNewConversation(participantId);
    setShowNewConversationModal(false);
  };

  return (
    <div className="conversations_list">
      {/* Header */}
      <div className="conversations_header">
        <div className="conversations_title">
          <h2>Chats</h2>
          <button
            className="new_conversation_btn"
            onClick={() => setShowNewConversationModal(true)}
            title="New conversation"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </button>
        </div>


      </div>

      {/* Conversations List */}
      <div className="conversations_content">
        {loading ? (
          <div className="conversations_skeleton">
            {Array(10).fill(0).map((_, i) => (
              <div key={i} className="conversation_skeleton">
                <Skeleton circle height={56} width={56} />
                <div className="conversation_skeleton_content">
                  <Skeleton height={16} width="60%" />
                  <Skeleton height={14} width="80%" />
                </div>
              </div>
            ))}
          </div>
        ) : conversations.length === 0 ? (
          <div className="no_conversations">
            <div className="no_conversations_content">
              <div className="no_conversations_icon">
                <i className="messenger_icon"></i>
              </div>
              <h3>No conversations yet</h3>
              <p>Start a new conversation to begin chatting</p>
              <button
                className="start_conversation_btn"
                onClick={() => setShowNewConversationModal(true)}
              >
                Start New Conversation
              </button>
            </div>
          </div>
        ) : (
          conversations
            .sort((a, b) => {
              // Sort pinned conversations first, then by last activity
              if (a.pinned && !b.pinned) return -1;
              if (!a.pinned && b.pinned) return 1;
              return new Date(b.lastActivity || 0) - new Date(a.lastActivity || 0);
            })
            .map((conversation) => (
            <ConversationItem
              key={conversation._id}
              conversation={conversation}
              currentUser={currentUser}
              isSelected={selectedConversation?._id === conversation._id}
              onSelect={() => onConversationSelect(conversation)}
              isOnline={
                conversation.type === 'private' &&
                (() => {
                  const otherUser = conversation.participants.find(p => p._id !== currentUser.id);
                  if (!otherUser || !onlineUsers || !onlineUsers.size) return false;
                  const otherUserId = String(otherUser._id);
                  return Array.from(onlineUsers).some(id => String(id) === otherUserId);
                })()
              }
              onConversationDeleted={onConversationDeleted}
            />
          ))
        )}
      </div>

      {/* New Conversation Modal */}
      {showNewConversationModal && (
        <NewConversationModal
          currentUser={currentUser}
          onStartConversation={handleNewConversation}
          onClose={() => setShowNewConversationModal(false)}
        />
      )}
    </div>
  );
} 